import { EventEmitter } from 'events';

const apiEventEmitter = new EventEmitter();

export default apiEventEmitter;
